import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79537d6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Compras", -1))
const _hoisted_2 = { class: "cartas" }

import CardComponent from '@/components/PortalComponents/CardComponent.vue';
    import { useRouter } from 'vue-router';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ShoppingView',
  setup(__props) {
 

    const router = useRouter();

    const redirectToCreate = () => {
        router.push({name: 'createShopping'})
    }

    const redirectToHistory = () => {
        router.push({name: 'historyShopping'})
    }

    const redirectToStats = () => {
        router.push({name: 'statsShopping'})
    }

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CardComponent, {
        onClick: redirectToCreate,
        class: _normalizeClass('card-global'),
        image: "https://i.imgur.com/MD4yrXa.png",
        title: 'Registrar compra',
        content: 'Puedes registrar datos de la compra'
      }),
      _createVNode(CardComponent, {
        onClick: redirectToHistory,
        class: _normalizeClass('card-global'),
        image: "https://i.imgur.com/0vz9Bpm.png",
        title: 'Historial de compras',
        content: 'Puedes ver el historial de tus compras'
      }),
      _createVNode(CardComponent, {
        onClick: redirectToStats,
        class: _normalizeClass('card-global'),
        image: "https://i.imgur.com/StU4MFX.png",
        title: 'Estadísticas de compras',
        content: 'Puedes ver las estadísticas de tus compras'
      })
    ]),
    _createVNode(_component_RouterView)
  ]))
}
}

})